import React from 'react';


/**
 * Products Cards Remover component
 */
const ProductCardsRemover = (props) => (
    <div className="nppe2-fc-product-cards-map">
      {
        Object.entries(props.selectedData).map(([key, product]) =>
            <div key={key} className={"nppe2-fc-close-button " + product.types[0].replace(' ', '-').toLowerCase() }>
              <div className="nppe2-fc-close-button__btn">
                <div
                    className="nppe2-fc-close-button__text nppe2-fc-full-width">{product.label}</div>
                <div className="nppe2-fc-close-button__close">
                  <a onClick={() => props.onRemove(product.id)}>
                    x
                  </a>
                </div>
              </div>
            </div>
        )
      }
    </div>
);

export default ProductCardsRemover;
